export default {"src":"/_next/static/media/wax.8d432853.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};